import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  grid-area: content;
  display: grid;
  gap: ${rem(12)} ${rem(32)};
  grid-template-columns: 1fr;
  grid-auto-rows: min-content;

  ${mediaQueryUp.tablet} {
    gap: ${rem(12)} ${rem(16)};
  }

  ${mediaQueryUp.desktop} {
    gap: ${rem(12)} ${rem(32)};
    grid-template-columns: ${rem(238)} 1fr;
  }
`

function AccommodationPackageTileContentArea(props: PropsWithChildren) {
  return <Container {...props} />
}

export default AccommodationPackageTileContentArea
